import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { IPhoneCall, IPhoneCallCategory } from '../../../../extViewmodels';
import { usePhoneCallCategory } from '../../../entities/PhoneCall/usePhoneCallCategory';
import { CategoryListBuilder } from '../../CategoryListBuilder';
import { useTagList } from '../../LeadRuleModal/utils';
import { styleSheet } from '../styles';

interface IProps {
	phoneCallCategories: IPhoneCallCategory[];
	phoneCallId: string;
}

export const CallDetailsCategory: React.FC<IProps> = ({ phoneCallCategories, phoneCallId }) => {
	const [categories, addCategory, removeCategory, setCategories] = useTagList([]);
	const [categoryObjects, setCategoryObjects] = useState(null);

	const phoneCallCategory = usePhoneCallCategory<IPhoneCall>();

	useEffect(() => {
		if (phoneCallCategories) {
			setCategoryObjects(phoneCallCategories);
			setCategories(phoneCallCategories?.map(c => c.name));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [phoneCallCategories]);

	useEffect(() => {
		if (phoneCallCategory?.data?.categories) {
			setCategoryObjects(phoneCallCategory?.data?.categories);
		}
	}, [phoneCallCategory.data]);

	const handleAddCategory = (category: string) => {
		addCategory(category);
		phoneCallCategory.addToPhoneCall(phoneCallId, category);
	};

	const handleRemoveCategory = (category: string) => {
		removeCategory(category);
		phoneCallCategory.removeFromPhoneCall(phoneCallId, category);
	};

	return (
		<div>
			<div className={css(styleSheet.sectionTitle)}>Call Categories</div>
			<CategoryListBuilder
				categoryObjects={categoryObjects}
				categories={categories}
				onAdd={handleAddCategory}
				onRemove={handleRemoveCategory}
			/>
		</div>
	);
};
